import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let router = new Router({
    mode: 'history',
    routes: [{
            path: '',
            redirect: 'login'
        },
        {
            path: '/login',
            name: 'Login',
            component: () =>
                import ('@/views/Onboarding/login')
        },
        {
            path: '/onboarding',
            name: 'Onboarding Walkthrough',
            component: () =>
                import ('@/views/Onboarding/onboarding')
        },
        {
            path: '/otp',
            name: 'OTP',
            component: () =>
                import ('@/views/Onboarding/otp')
        }, {
            path: '/change-password',
            name: 'Set New Password',
            component: () =>
                import ('@/views/Onboarding/change-password')
        }, {
            path: '/logout',
            name: 'Logout',
            component: () =>
                import ('@/views/Onboarding/logout')
        },
        {
            path: '/register',
            name: 'Register',
            component: () =>
                import ('@/views/Onboarding/register')

        },
        {
            path: '/terms&conditions',
            name: 'Terms And Conditions',
            component: () =>
                import ('@/views/Onboarding/terms-conditions')

        },
        {
            path: '/declaration',
            name: 'Declaration',
            component: () =>
                import ('@/views/Onboarding/declaration')
        },
        {
            path: '/reset-password',
            name: 'Reset Password',
            component: () =>
                import ('@/views/Onboarding/reset_password')
        },
        {
            path: '/reset-password/:token',
            name: 'Reset Password',
            component: () =>
                import ('@/views/Onboarding/reset_password')
        },
        {
            path: '/account-active/:token',
            name: 'Verify Email',
            component: () =>
                import ('@/views/Onboarding/verify-email')
        },
        {
            path: '/complete-profile/:token',
            name: 'Set Password',
            component: () =>
                import ('@/views/Onboarding/terms-conditions-policies')
        },
        {
            path: '/',
            component: () =>
                import ('@/views/main'),
            meta: {
                requiresAuth: true
            },
            children: [{
                    path: '/dashboard',
                    name: 'Dashboard',
                    component: () =>
                        import ('@/views/Dashboard/employer-home')
                },
                {
                    path: '/home',
                    name: 'Dashboard',
                    component: () =>
                        import ('@/views/Dashboard/home')
                },
                {
                    path: '/my-profile',
                    name: 'My Profile',
                    component: () =>
                        import ('@/views/Onboarding/my-profile')
                },
                {
                    path: '/banks',
                    name: 'Setup Banks',
                    component: () =>
                        import ('@/views/Setting/setup-bank')
                }, {
                    path: '/fee-types',
                    name: 'Setup Fee Type',
                    component: () =>
                        import ('@/views/Setting/fee-type')
                }, {
                    path: '/templates',
                    name: 'Setup Message Template',
                    component: () =>
                        import ('@/views/Setting/message-template')
                },
                {
                    path: '/edit-template/:id/:viewType',
                    name: 'Edit Message Template',
                    component: () =>
                        import ('@/views/Setting/edit-template')
                }, {
                    path: '/country',
                    name: 'Setup Countries, States & Cities',
                    component: () =>
                        import ('@/views/Setting/country')
                }, {
                    path: '/state',
                    name: 'Setup Countries, States & Cities',
                    component: () =>
                        import ('@/views/Setting/state')
                }, {
                    path: '/city',
                    name: 'Setup Countries, States & Cities',
                    component: () =>
                        import ('@/views/Setting/city')
                }, {
                    path: '/misc-configuration',
                    name: 'Miscellaneous Configuration',
                    component: () =>
                        import ('@/views/Setting/miscellaneous-configuration')
                }, {
                    path: '/password-policies',
                    name: 'Password Policy Configuration',
                    component: () =>
                        import ('@/views/Setting/password-policy')
                }, {
                    path: '/roles',
                    name: 'Manage Roles',
                    component: () =>
                        import ('@/views/Setting/role')
                }, {
                    path: '/add-role',
                    name: 'Add Role',
                    component: () =>
                        import ('@/views/Setting/add-role')
                }, {
                    path: '/edit-role/:id/:type/:viewType',
                    name: 'Edit Role',
                    component: () =>
                        import ('@/views/Setting/add-role')
                },
                {
                    path: '/view-role/:id/:type/:viewType',
                    name: 'View Role',
                    component: () =>
                        import ('@/views/Setting/add-role')
                },
                {
                    path: '/companies',
                    name: 'Manage Company',
                    component: () =>
                        import ('@/views/UserManagement/manage-company')
                }, {
                    path: '/add-manage-company',
                    name: 'Add Company',
                    component: () =>
                        import ('@/views/UserManagement/add-manage-company')
                }, {
                    path: '/edit-manage-company/:id/:viewType',
                    name: 'Edit Company',
                    component: () =>
                        import ('@/views/UserManagement/add-manage-company')
                },
                {
                    path: '/admin',
                    name: 'Manage System Admin',
                    component: () =>
                        import ('@/views/UserManagement/manage-system-user')
                }, {
                    path: '/add-manage-system-user',
                    name: 'Add System Admin',
                    component: () =>
                        import ('@/views/UserManagement/add-manage-system-user')
                }, {
                    path: '/edit-manage-system-user/:id/:viewType',
                    name: 'Edit System Admin',
                    component: () =>
                        import ('@/views/UserManagement/add-manage-system-user')
                }, {
                    path: '/employee',
                    name: 'Manage Employee User',
                    component: () =>
                        import ('@/views/UserManagement/manage-employee-user')
                },
                {
                    path: '/add-employee-user',
                    name: 'Add Employee User',
                    component: () =>
                        import ('@/views/UserManagement/add-manage-employee-user')
                },
                {
                    path: '/edit-employee-user/:id/:company_id/:viewType',
                    name: 'Edit Employee User',
                    component: () =>
                        import ('@/views/UserManagement/add-manage-employee-user')
                },
                {
                    path: '/employers',
                    name: 'Manage Employer Admin',
                    component: () =>
                        import ('@/views/UserManagement/manage-employer-admin')
                }, {
                    path: '/add-employer-admin',
                    name: 'Add Employer Admin',
                    component: () =>
                        import ('@/views/UserManagement/add-manage-employer-admin')
                }, {
                    path: '/edit-employer-admin/:id/:viewType',
                    name: 'Edit Employer Admin',
                    component: () =>
                        import ('@/views/UserManagement/add-manage-employer-admin')
                },
                {
                    path: '/news-announcements',
                    name: 'News & Announcement',
                    component: () =>
                        import ('@/views/NewsAndAnnouncement/news-and-announcement')
                },
                {
                    path: '/privacy-policy',
                    name: 'Privacy Policy',
                    component: () =>
                        import ('@/views/Support/privacy')
                },
                {
                    path: '/terms-conditions',
                    name: 'Terms And Conditions',
                    component: () =>
                        import ('@/views/Support/term')
                },
                {
                    path: '/announcements',
                    name: 'News & Announcement',
                    component: () =>
                        import ('@/views/NewsAndAnnouncement/view-news-and-announcement')
                },
                {
                    path: '/news-announcements-detail/:id',
                    name: 'News & Announcement',
                    component: () =>
                        import ('@/views/NewsAndAnnouncement/view-news-and-announcement-details')
                },
                {
                    path: '/add/news-announcement',
                    name: 'News & Announcement',
                    component: () =>
                        import ('@/views/NewsAndAnnouncement/news-and-updates')
                },
                {
                    path: '/edit/news-announcement/:id',
                    name: 'Edit News & Announcement',
                    component: () =>
                        import ('@/views/NewsAndAnnouncement/news-and-updates')
                },
                {
                    path: '/view/news-announcement/:id',
                    name: 'View News & Announcement',
                    component: () =>
                        import ('@/views/NewsAndAnnouncement/view-news-announcement-employer')
                },
                {
                    path: 'static/terms-conditions',
                    name: 'Term And Condition',
                    component: () =>
                        import ('@/views/Support/terms-and-condition')
                }, {
                    path: 'static/privacy-policy',
                    name: 'Privacy Policy',
                    component: () =>
                        import ('@/views/Support/privacy-policy')
                }, {
                    path: '/static/faq',
                    name: 'FAQ\'s',
                    component: () =>
                        import ('@/views/Support/faq')
                },
                {
                    path: '/faq',
                    name: 'FAQ',
                    component: () =>
                        import ('@/views/Support/view-faq')
                },
                {
                    path: '/add-faq',
                    name: 'Add FAQ',
                    component: () =>
                        import ('@/views/Support/add-faq')
                },
                {
                    path: '/edit-faq/:id/:viewType',
                    name: 'Edit FAQ',
                    component: () =>
                        import ('@/views/Support/add-faq')
                },
                {
                    path: '/about',
                    name: 'About Us',
                    component: () =>
                        import ('@/views/Support/about-us')
                },
                {
                    path: '/about-us',
                    name: 'About Us Employee',
                    component: () =>
                        import ('@/views/Support/about-us-employee')
                },
                {
                    path: '/static/feedback',
                    name: 'Feedback',
                    component: () =>
                        import ('@/views/Support/feedback')
                },
                {
                    path: '/feedback',
                    name: 'Feedback',
                    component: () =>
                        import ('@/views/Support/add-feedback')
                },
                {
                    path: '/view-notifications',
                    name: 'Notification List',
                    component: () =>
                        import ('@/views/Support/notifications')
                },
                {
                    path: '/view-notifications/:id',
                    name: 'Notification',
                    component: () =>
                        import ('@/views/Support/notification-details')
                },
                {
                    path: '/static/disclaimer',
                    name: 'Disclaimer',
                    component: () =>
                        import ('@/views/Support/disclaimer')
                },
                {
                    path: '/derive-net-salary',
                    name: 'Derive Net Salary',
                    component: () =>
                        import ('@/views/Support/derive-net-salary-from-gross-salary')
                },
                // {
                //     path: '/derive-net-salary',
                //     name: 'DeriveNetSalary',
                //     component: () =>
                //         import ('@/views/Reports/reports')
                // },
                {
                    path: '/promotions',
                    name: 'Promotion Profile',
                    component: () =>
                        import ('@/views/Promotion/promotion-role')
                },
                {
                    path: '/refferal-configuration',
                    name: 'Refferal Configuration',
                    component: () =>
                        import ('@/views/Promotion/refferel-configuration')
                }, {
                    path: '/ewa-configuration',
                    name: 'Earned Salary Transaction Configuration',
                    component: () =>
                        import ('@/views/TransctionConfiguration/ewa-config')
                },
                {
                    path: '/add-ewa-transaction',
                    name: 'Add Earned Salary Configuration',
                    component: () =>
                        import ('@/views/TransctionConfiguration/add-ewa-config')
                },
                {
                    path: '/edit-ew-transaction/:id/:viewType',
                    name: 'Edit Earned Salary Configuration',
                    component: () =>
                        import ('@/views/TransctionConfiguration/add-ewa-config')
                },
                {
                    path: '/sa-scheme',
                    name: 'Setup Salary Advance Scheme',
                    component: () =>
                        import ('@/views/TransctionConfiguration/setup-salary-advance-scheme')
                },
                {
                    path: '/add-sa-scheme',
                    name: 'Add Salary Advance Scheme',
                    component: () =>
                        import ('@/views/TransctionConfiguration/add-setup-salary-advance-scheme')
                },
                {
                    path: '/edit-sa-scheme/:id/:viewType',
                    name: 'Edit Salary Advance Scheme',
                    component: () =>
                        import ('@/views/TransctionConfiguration/add-setup-salary-advance-scheme')
                },
                {
                    path: '/earned-wage-request',
                    name: 'Pending Earned Salary Request',
                    component: () =>
                        import ('@/views/Transaction/pending-earned-wage-request')
                },
                {
                    path: '/billing-statements',
                    name: 'Manage Billing Statements',
                    component: () =>
                        import ('@/views/Transaction/manage-billing-statement')
                },
                {
                    path: '/repayments',
                    name: 'Manage Repayment Statements',
                    component: () =>
                        import ('@/views/Transaction/manage-repayment-statement')
                },
                {
                    path: '/edit-repayments',
                    name: 'Edit Repayment Statement',
                    component: () =>
                        // import ('@/views/Transaction/edit-manage-repayment')
                        import ('@/views/Transaction/edit-import-repayment')
                },
                {
                    path: '/reconciliation',
                    name: 'Reconciliation',
                    component: () =>
                        import ('@/views/Transaction/reconciloation')
                },
                {
                    path: '/add-manage-repayment-statement',
                    name: 'Add Repayment Statement',
                    component: () =>
                        import ('@/views/Transaction/edit-import-repayment')
                },
                {
                    path: '/edit-manage-repayment-statement/:id/:viewType',
                    name: 'Edit Repayment Statement',
                    component: () =>
                        import ('@/views/Transaction/edit-import-repayment')
                },
                {
                    path: '/rejected-earned-wage-request',
                    name: 'Rejected Earned Salary Requst',
                    component: () =>
                        import ('@/views/Transaction/rejected-earned-wage-request')
                },
                {
                    path: '/approve-earned-wage-request',
                    name: 'Approved Earned Salary Request',
                    component: () =>
                        import ('@/views/Transaction/approve-earned-wage-request')
                },
                {
                    path: '/view-approve-earned-wage-request/:id',
                    name: 'View :: Earned Salary Request',
                    component: () =>
                        import ('@/views/Transaction/view-approve-earned-wage-request')
                },
                {
                    path: '/ewa-request/:id',
                    name: 'View :: Earned Salary Request',
                    component: () =>
                        import ('@/views/Transaction/view-approve-reject-earned-request')
                },
                {
                    path: '/sa-request',
                    name: 'Pending :: SA Transactions',
                    component: () =>
                        import ('@/views/Transaction/pending-salary-advance-request')
                },
                {
                    path: '/approve-sa-request',
                    name: 'Approved :: SA Transactions',
                    component: () =>
                        import ('@/views/Transaction/approve-salary-advance-request')
                },
                {
                    path: '/disclaimer',
                    name: 'Disclaimer',
                    component: () =>
                        import ('@/views/Support/view-disclaimer')
                },
                {
                    path: '/rejected-sa-request',
                    name: 'Rejected :: SA Transactions',
                    component: () =>
                        import ('@/views/Transaction/rejected-salary-advance-request')
                },
                {
                    path: '/view-approve-salary-advance-request/:id',
                    name: 'View:: SA Request',
                    component: () =>
                        import ('@/views/Transaction/view-approve-salary-advance-request')
                },
                {
                    path: '/view-approve-salary-request/:id',
                    name: 'View:: SA Request',
                    component: () =>
                        import ('@/views/Transaction/view-approve-reject-salary-request')
                },
                {
                    path: '/add-promotion-profile',
                    name: 'Add Promotion Profile',
                    component: () =>
                        import ('@/views/Promotion/add-promotion-profile')
                },
                {
                    path: '/edit-promotion-profile/:id/:viewType',
                    name: 'Edit Promotion Profile',
                    component: () =>
                        import ('@/views/Promotion/add-promotion-profile')
                }, {
                    path: '/reports',
                    name: 'Reports',
                    component: () =>
                        import ('@/views/Reports/reports')
                },
                {
                    path: '/employer-reports',
                    name: 'Employer Reports',
                    component: () =>
                        import ('@/views/Reports/employer-report')
                },
                {
                    path: '/employer-transaction-reports',
                    name: 'Employer Transaction Reports',
                    component: () =>
                        import ('@/views/Reports/employer-transaction-report')
                },
                {
                    path: '/view-access-log',
                    name: 'View Access Log',
                    component: () =>
                        import ('@/views/Reports/view-user-access-log')
                },
                {
                    path: '/refer-friend',
                    name: 'Refer A friend',
                    component: () =>
                        import ('@/views/Reports/refer-a-friend')
                },
                {
                    path: '/employee-transaction-reports',
                    name: 'Employee Transaction Reports',
                    component: () =>
                        import ('@/views/Reports/employee-report')
                },
                {
                    path: '/bank-interface-log',
                    name: 'Bank Interface Log',
                    component: () =>
                        import ('@/views/Reports/bank-interface-log')
                }, {
                    path: '/transction-listing-detail',
                    name: 'Transction Listing',
                    component: () =>
                        import ('@/views/Reports/transction-listing-detailv2')
                },
                , {
                  path: '/transction-listing-detailv2',
                  name: 'Transction Listing & Detail',
                  component: () =>
                      import ('@/views/Reports/transction-listing-detailv2')
              }, {
                    path: '/earning-reports',
                    name: 'Earning Reports',
                    component: () =>
                        import ('@/views/Reports/earning-reportsv2')
                }, {
                  path: '/earning-reportsv2',
                  name: 'Earning Reports',
                  component: () =>
                      import ('@/views/Reports/earning-reportsv2')
              },
                {
                    path: '/promotion-reports',
                    name: 'Promotion Reports',
                    component: () =>
                        import ('@/views/Reports/promotion-reports')
                },
                {
                    path: '/referrel-reports',
                    name: 'Referral Transaction Reports',
                    component: () =>
                        import ('@/views/Reports/referrel-report')
                }, {
                    path: '/view-disbursement-collection',
                    name: 'Disbursement & Collection Report',
                    component: () =>
                        import ('@/views/Reports/view-disbursement-collection')
                },
                {
                    path: '/users-listing',
                    name: 'User Listing',
                    component: () =>
                        import ('@/views/Reports/users-listing')
                }, {
                    path: '/aging-report',
                    name: 'Aging Report',
                    component: () =>
                        import ('@/views/Reports/aging-report2')
                },
                , {
                  path: '/aging-reportv2',
                  name: 'Aging Report',
                  component: () =>
                      import ('@/views/Reports/aging-report2')
              },
                {
                    path: '/view-audit-trail',
                    name: 'Audit Trail',
                    component: () =>
                        import ('@/views/Reports/view-audit-trail')
                },
                {
                    path: '/view-api-log',
                    name: 'Api Log',
                    component: () =>
                        import ('@/views/Reports/api-log')
                }, {
                    path: '/salary-advance',
                    name: 'Request for Salary Advance',
                    component: () =>
                        import ('@/views/SalaryAdvance/list')
                },
                {
                    path: '/ewa',
                    name: "Request Earned Salary",
                    component: () =>
                        import ('@/views/EarnedWages/request-earned-wages')
                }, {
                    path: '/support-documents',
                    name: 'Setup Supporting Document',
                    component: () =>
                        import ('@/views/TransctionConfiguration/setup-supporting-document')
                }, {
                    path: '/add-support-documents',
                    name: 'Add Setup Supporting Document',
                    component: () =>
                        import ('@/views/TransctionConfiguration/add-setup-supporting')
                },
                {
                    path: '/ewa-config',
                    name: 'Add Earned Salary Config',
                    component: () =>
                        import ('@/views/TransctionConfiguration/ewa-config-employer')
                },
                {
                    path: '/edit-support-documents/:id/:viewType',
                    name: 'Edit Setup Supporting Document',
                    component: () =>
                        import ('@/views/TransctionConfiguration/add-setup-supporting')
                }, {
                    path: '/access-denied',
                    name: 'Access Denied',
                    component: () =>
                        import ('@/views/Error/access-denied')
                },
                {
                    path: '/access-denied-dashboard',
                    name: 'Access Denied Dashboard',
                    component: () =>
                        import ('@/views/Error/access-denied-dashboard')
                },
            ]
        }
    ]
})

router.beforeEach((to, from, next) => {
    document.title = `${process.env.APP_TITLE} :: ${to.name}`
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!localStorage.getItem('token') || localStorage.getItem('token') == null || localStorage.getItem('isVerify') == null) {
            next({
                path: '/login',
                params: { nextUrl: to.fullPath }
            })
        } else {
            next()
        }
    } else {
        if (to.path === '/login') {
            if (localStorage.getItem('token') != null && localStorage.getItem('isVerify') != null) {
                if (process.env.IS_ADMIN) {
                    next({
                        path: '/dashboard',
                        params: { nextUrl: to.fullPath }
                    })
                } else {
                    next({
                        path: '/dashboard',
                        params: { nextUrl: to.fullPath }
                    });
                }
            } else {
                next()
            }
        } else {
            next()
        }
    }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js